import { cloneDeep } from 'lodash-es';
import { options, TriggerView, ApiTrigger } from './triggers.models';
import * as Util from './triggers.util';

export default function AlertsViewTriggersControllerCRUD(
  $scope,
  $rootScope,
  $stateParams,
  $filter,
  configurationsService,
  gettextCatalog,
  ConfigurationFilterService,
) {
  'ngInject';

  //Local Varaiables
  let currentUser = $rootScope.currentUser;
  let configurationId = $stateParams.configurationId;
  let orderBy = $filter('orderBy');

  const vm = this;

  let filterDefaultDataPointDescriptors = () => {
    let descriptors = cloneDeep($rootScope.datapointDescriptors);
    descriptors.forEach(descriptor => {
      if (descriptor.values.hasOwnProperty('default')) {
        delete descriptor.values['default'];
      }
    });
    return descriptors;
  };
  //Public Variables
  $scope.dataPointDescriptors = filterDefaultDataPointDescriptors();
  $scope.descriptorVisible = false; //used to change the thresholdValue input from select dropdown to numerical input
  $scope.deleteTriggerFlag = false; //hide or show deleteTriggerMessage
  $scope.deleteTriggerText = gettextCatalog.getString(
    'You must have at least one Trigger per Configuration.',
  );
  $scope.duplicateConditionFlag = false;
  $scope.duplicateConditionText = gettextCatalog.getString(
    'The condition must be unique when using the same data point on multiple triggers. Change the condition and try saving the trigger again.',
  );
  $scope.filteredTriggerList = []; //Container for triggers that meet search criteria
  $scope.hasNewTrigger = false;
  $scope.loading = false;
  $scope.savedTriggers = [];
  $scope.search = {
    text: '',
  };
  $scope.sortedEvents = [];
  $scope.triggerData = [];
  $scope.triggers = [];
  $scope.disableDataPointDropdown = true;
  $scope.validationFlag = false;

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 15;
  $scope.maxSize = 1;

  //Sorting
  $scope.eventPropertyName = 'description'; //sort datapoint dropdown
  $scope.predicate = 'dataPoint.description'; //sort triggers by datapoint
  $scope.reverse = true;

  $scope.showKMLabel = false;

  /** Public Functions */
  //Sort filteredTriggerList
  $scope.orderTriggersList = function(predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = true;
    }
    $scope.predicate = predicate;
  };

  //applyFilter searchs the triggers[] for anything matching the search input.
  $scope.applyFilter = function() {
    $scope.filteredTriggerList = $filter('filter')($scope.triggers, $scope.search.text);

    if ($scope.search.text !== '' && $scope.hasNewTrigger) {
      // This ensure that if the user has input some search criteria that the new trigger row will always show
      // first item in the list is always the new trigger
      $scope.filteredTriggerList = [$scope.triggers[0], ...$scope.filteredTriggerList];
    }
  };

  //Adds a new row to the triggers table
  $scope.addTrigger = function() {
    $scope.currentPage = 1;
    if (!$scope.hasNewTrigger) {
      $scope.showKMLabel = false;
      $scope.trigger = new TriggerView($scope.triggers.length + 1);
      $scope.triggers.unshift($scope.trigger);
      $scope.disableDataPointDropdown = false;
      $scope.hasNewTrigger = true;
      $scope.deleteTriggerFlag = false;
      $scope.descriptorVisible = false;
    }
  };

  //Trigger Form Validation - Checks the values of each editable control before submitting the form.
  $scope.checkIfString = function(data) {
    if (data === '' || data === null) {
      $scope.validationFlag = true;
      return gettextCatalog.getString('required');
    }
  };

  $scope.checkNumericalValue = function(data) {
    if (isNaN(data)) {
      return gettextCatalog.getString('invalid number');
    } else {
      return $scope.checkIfString(data);
    }
  };

  //Validate the duration input before saving the trigger model to make sure we have not exceeded 24hrs
  //Need to disable the cancel button to force the user to change the duration
  $scope.checkDurationValue = function(data, triggerForm) {
    let maxTime = {
      hours: 24,
      minutes: 1440,
      seconds: 86400,
    };
    let max = maxTime[triggerForm.$data.unitOfTime];
    if (isNaN(data)) {
      return gettextCatalog.getString('invalid number');
    } else if (data > max) {
      $scope.disableCancel = true;
      return gettextCatalog.getString('max limit ' + max);
    } else {
      $scope.disableCancel = false;
      return $scope.checkIfString(data);
    }
  };

  //Before saving a new trigger we want to check the triggers[] to prevent saving duplicate trigger conditons for the same event
  $scope.validateTrigger = function(trigger) {
    $scope.duplicateConditionFlag = false;
    $scope.deleteTriggerFlag = false;
    $scope.hasNewTrigger = false;

    //remove duplicate trigger from savedTriggers array
    for (let i = 0; i < $scope.savedTriggers.length; i++) {
      if (trigger.id && trigger.id === $scope.savedTriggers[i].id) {
        $scope.savedTriggers.splice(i, 1);
        break;
      }
    }

    //validate the datapoint and condition
    if ($scope.savedTriggers.length >= 1) {
      const sameTriggers = $scope.savedTriggers.filter(saved =>
        Util.isSameTriggers(trigger, saved),
      );
      if (sameTriggers.length > 0) {
        $scope.duplicateConditionFlag = true;
        $scope.hasNewTrigger = true;
        return 'Duplicate Condition';
      }
    }

    if ($scope.duplicateConditionFlag === false) {
      //push savedTrigger model
      $scope.savedTriggers.push(trigger);
      //reset trigger model
      $scope.trigger = {};
      //enable add trigger button
      $scope.hasNewTrigger = false;
      createTrigger(trigger);
      $scope.disableDataPointDropdown = true;
    }
  };

  vm.$onInit = () => {
    $scope.priorityOptions = options.priorityOptions;
    $scope.relationalSymbolsOptions = options.relationalSymbolsOptions;
    $scope.unitOfTimeOptions = options.unitOfTimeOptions;
    $scope.clearOptions = options.clearOptions;
    $scope.notifyOnReturnOptions = options.notifyOnReturnOptions;

    //create indexed objects for easy retrieve
    $scope.indexedPriorityOptions = options.indexedPriorityOptions;
    $scope.indexedRelationalSymbolsOptions = options.indexedRelationalSymbolsOptions;
    $scope.indexedUnitOfTimeOptions = options.indexedUnitOfTimeOptions;
    $scope.indexedClearOptions = options.indexedClearOptions;
    $scope.indexedNotifyOnReturnOptions = options.indexedNotifyOnReturnOptions;

    getConfigurationTriggersData();
  };

  //Remove all of the selected users
  $scope.removeTrigger = function(triggerId) {
    if ($scope.triggers && $scope.triggers.length !== 1) {
      configurationsService
        .deleteConfigurationTrigger(configurationId, triggerId)
        .then(function() {
          return configurationsService.getConfigurationById(configurationId);
        })
        .then(function(response) {
          if (!response) {
            return;
          }
          $scope.triggerData = Util.validateTriggersData(
            response.data.triggers.data,
            currentUser.visibleDatapoints,
          );
          displayTriggers();
        })
        .catch(function() {
          let errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving configuration information.',
          );
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
        })
        .finally(function() {
          $scope.loading = false;
        });
    } else {
      $scope.deleteTriggerFlag = true;
    }
  };

  $scope.cancelTrigger = function() {
    if ($scope.triggers.length > $scope.savedTriggers.length) {
      $scope.triggers.splice(0, 1);
    }
    $scope.hasNewTrigger = false;
  };

  $scope.sortComparator = function(v1, v2) {
    // This ensure that when sorting that the new trigger row is always the first in the list no matter which direction
    if (typeof v1.value === 'undefined') {
      return $scope.reverse ? 1 : -1;
    } else if (typeof v2.value === 'undefined') {
      return $scope.reverse ? -1 : 1;
    }

    return v1.index < v2.index ? -1 : 1;
  };

  /**
   * when selected of data point changes
   * dropdowns options in condition section should change
   */
  $scope.datapointSelected = function(data = {}, trigger = {}) {
    $scope.showKMLabel = data.id === 'speed' ? true : false;
    //Changes the dropdown options shown in the condition
    const datapointDescriptor = $scope.dataPointDescriptors.find(
      dsc => data.id && data.id === dsc.key,
    );
    if (
      datapointDescriptor &&
      datapointDescriptor.values &&
      Object.keys(datapointDescriptor.values).length > 0
    ) {
      $scope.relationalSymbolsOptions = options.relationalSymbolsOptions.filter(
        option => option.stateRelational,
      );
      trigger.valuesDescriptors = datapointDescriptor.values;
    } else {
      $scope.relationalSymbolsOptions = options.relationalSymbolsOptions;
      trigger.valuesDescriptors = undefined;
    }
  };
  /**
   * on edit the row
   * dropdowns options in condition section should reset to what suit data point
   */
  $scope.getDataPointInfoOnEdit = function(trigger) {
    $scope.cancelTrigger();
    $scope.showKMLabel = trigger.dataPoint.id === 'speed' ? true : false;
    if (trigger && trigger.valuesDescriptors) {
      $scope.relationalSymbolsOptions = options.relationalSymbolsOptions.filter(
        option => option.stateRelational,
      );
    } else {
      $scope.relationalSymbolsOptions = options.relationalSymbolsOptions;
    }
  };

  //Post new trigger to configuration
  function submitTrigger(newTrigger) {
    $scope.errorFlag = false;

    configurationsService
      .postConfigurationTrigger(configurationId, newTrigger)
      .then(function() {
        return configurationsService.getConfigurationById(configurationId);
      })
      .then(function(response) {
        if (!response) {
          return;
        }

        $scope.triggerData = Util.validateTriggersData(
          response.data.triggers.data,
          currentUser.visibleDatapoints,
        );
        displayTriggers();
      })
      .catch(function() {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving configuration information.',
        );
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
      })
      .finally(function() {
        $scope.loading = false;
      });
  }

  function displayTriggers() {
    $scope.triggers = [];
    $scope.savedTriggers = [];
    getDataPoints();

    //Take each property found in each trigger and make them readable to the user
    $scope.triggerData.forEach(apiTrigger => {
      //use sortedEvents as it has all visible data points after applying data point descriptor to it
      const dataPoint = $scope.sortedEvents.find(
        datapointEvent => apiTrigger.dataPoint === datapointEvent.id,
      );
      const datapointDescriptor = $scope.dataPointDescriptors.find(
        dsc => apiTrigger.dataPoint === dsc.key,
      );
      const trigger = Util.apiToTriggerView(apiTrigger, dataPoint, datapointDescriptor);
      $scope.triggers.push(trigger);
      $scope.savedTriggers.push(trigger);
    });

    $scope.filteredTriggerList = $scope.triggers.slice();
    $scope.applyFilter();
    $scope.hasNewTrigger = false;
  }

  //get list of datapoints to display in UI.
  function getDataPoints() {
    const copyVisibleDataPoints = cloneDeep(currentUser.visibleDatapoints);
    const dataPointDescriptors = $scope.dataPointDescriptors;

    let events = copyVisibleDataPoints.map(visibleDataPoint => {
      let foundDpdesc = dataPointDescriptors.find(dpdesc => dpdesc.key === visibleDataPoint.id);

      // Assign the value of visibleDatapoint.descriptor if a match is found. Else keep the original value
      visibleDataPoint.description =
        foundDpdesc && foundDpdesc.title ? foundDpdesc.title : visibleDataPoint.description;
      return visibleDataPoint;
    });

    events = ConfigurationFilterService.filterInvalidDatapoints(events);

    $scope.sortedEvents = orderBy(events, $scope.eventPropertyName);
    return $scope.sortedEvents;
  }

  function createTrigger(trigger) {
    const newTrigger = new ApiTrigger(trigger);

    if (newTrigger.id === $scope.triggers.length) {
      submitTrigger(newTrigger);
    } else {
      updateTrigger(trigger, newTrigger);
    }
  }

  function updateTrigger(trigger, newTrigger) {
    $scope.errorFlag = false;

    configurationsService
      .updateConfigurationTrigger(configurationId, trigger.id, newTrigger)
      .then(function() {
        return configurationsService.getConfigurationById(configurationId);
      })
      .then(function(response) {
        if (!response) {
          return;
        }

        $scope.triggerData = Util.validateTriggersData(
          response.data.triggers.data,
          currentUser.visibleDatapoints,
        );
        displayTriggers();
      })
      .catch(function() {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving configuration information.',
        );
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
      })
      .finally(function() {
        $scope.loading = false;
      });
  }

  function getConfigurationTriggersData() {
    if (configurationId) {
      $scope.loading = true;
      configurationsService
        .getConfigurationById(configurationId)
        .then(function(response) {
          if (!response) {
            return;
          }

          $scope.triggerData = Util.validateTriggersData(
            response.data.triggers.data,
            currentUser.visibleDatapoints,
          );
          displayTriggers();
        })
        .catch(function(ex) {
          let errorMsg = gettextCatalog.getString(
            'An error occurred while retrieving configuration information.',
          );
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
        })
        .finally(function() {
          $scope.loading = false;
        });
    } else {
      $scope.loading = false;
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = gettextCatalog.getString(
        'Could not load page: no configuration Id provided.',
      );
    }
  }
}
